module.exports = __webpack_public_path__ + "img/atatürk-banner.be1d511a.png";